import { render, staticRenderFns } from "./imgrotate.vue?vue&type=template&id=6311d84a&"
import script from "./imgrotate.vue?vue&type=script&lang=js&"
export * from "./imgrotate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports